/* ==========================================================================
   IRON CREST LEATHER — blog.js
   Topic tabs and Load more for the journal index.

   Every article is in the markup. Both controls ship with the `hidden`
   attribute and are revealed here, so with no script the page is simply the
   full list — which is the correct fallback for a blog index and needs no
   apology.

   The tabs are derived from the tags on the cards rather than hard-coded, so
   adding an article with a new tag adds a tab. On Shopify this becomes
   blog.all_tags and the filter becomes a real /blogs/journal/tagged/<tag> link.
   ========================================================================== */
(function () {
  function boot() {
    'use strict';

    var grid = document.querySelector('[data-blog-grid]');
    if (!grid) return;
    if (grid.icBooted) return;   // already live; the editor replaced a different section
    grid.icBooted = true;

    var tabsWrap = document.querySelector('[data-blog-tabs]');
    var list = tabsWrap && tabsWrap.querySelector('.tabs__list');
    var moreBtn = document.querySelector('[data-blog-more]');
    var countEl = document.querySelector('[data-blog-count]');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.post'));
    if (!cards.length) return;

    var PAGE = 6;                 // how many show before Load more
    var active = 'all';
    var expanded = false;

    var LABELS = {
      all: 'Everything', craft: 'Craft', care: 'Care',
      styling: 'Styling', archive: 'Archive'
    };
    function label(key) {
      return LABELS[key] || key.charAt(0).toUpperCase() + key.slice(1);
    }

    /* ----------------------------------------------------------- the tabs */
    var keys = ['all'];
    cards.forEach(function (card) {
      (card.getAttribute('data-tags') || '').split(/\s+/).forEach(function (k) {
        if (k && keys.indexOf(k) === -1) keys.push(k);
      });
    });

    var tabs = [];
    var indicator = null;

    if (list && keys.length > 2) {
      keys.forEach(function (key, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tab';
        b.setAttribute('role', 'tab');
        b.setAttribute('data-key', key);
        b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        b.tabIndex = i === 0 ? 0 : -1;
        b.textContent = label(key);
        list.appendChild(b);
        tabs.push(b);
      });

      indicator = document.createElement('span');
      indicator.className = 'tabs__indicator';
      indicator.setAttribute('aria-hidden', 'true');
      list.appendChild(indicator);
      tabsWrap.hidden = false;
    }

    function moveIndicator() {
      if (!indicator) return;
      var on = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0];
      if (!on) return;
      var a = on.getBoundingClientRect(), l = list.getBoundingClientRect();
      indicator.style.transform =
        'translateX(' + (a.left - l.left + list.scrollLeft) + 'px) scaleX(' + a.width + ')';
    }

    /* --------------------------------------------------------- the filter */
    function matches(card) {
      if (active === 'all') return true;
      return (' ' + (card.getAttribute('data-tags') || '') + ' ').indexOf(' ' + active + ' ') !== -1;
    }

    function render() {
      var shown = 0;
      var inSet = cards.filter(matches);

      cards.forEach(function (card) {
        var ok = matches(card) && (expanded || shown < PAGE);
        if (ok) shown++;
        card.setAttribute('data-filtered', ok ? 'false' : 'true');
      });

      // re-index so the entry stagger runs in visual order, not source order
      var i = 0;
      cards.forEach(function (card) {
        if (card.getAttribute('data-filtered') === 'false') card.style.setProperty('--i', i++);
      });

      if (moreBtn) {
        moreBtn.hidden = expanded || inSet.length <= PAGE;
        moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
      if (countEl) {
        countEl.hidden = false;
        countEl.textContent = shown + ' of ' + inSet.length +
          (inSet.length === 1 ? ' article' : ' articles');
      }
    }

    function restage() {
      grid.setAttribute('data-entering', 'false');
      void grid.offsetWidth;
      grid.setAttribute('data-entering', 'true');
    }

    function select(key, focus) {
      if (key === active) return;
      active = key;
      expanded = false;                 // a new topic starts at the top again

      tabs.forEach(function (t) {
        var on = t.getAttribute('data-key') === key;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      moveIndicator();

      grid.setAttribute('data-filtering', 'true');
      setTimeout(function () {
        render();
        grid.setAttribute('data-filtering', 'false');
        restage();
      }, 180);
    }

    if (list) {
      list.addEventListener('click', function (e) {
        var t = e.target.closest('.tab');
        if (t) select(t.getAttribute('data-key'), false);
      });
      // roving tabindex, so the tablist behaves like one control
      list.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(document.activeElement);
        if (i === -1) return;
        var n = e.key === 'ArrowRight' ? i + 1
              : e.key === 'ArrowLeft' ? i - 1
              : e.key === 'Home' ? 0
              : e.key === 'End' ? tabs.length - 1 : -1;
        if (n === -1) return;
        e.preventDefault();
        n = (n + tabs.length) % tabs.length;
        select(tabs[n].getAttribute('data-key'), true);
      });
    }

    /* ------------------------------------------------------- the load more */
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        expanded = true;
        var first = cards.filter(function (c) {
          return c.getAttribute('data-filtered') === 'true' && matches(c);
        })[0];
        render();
        restage();
        // send focus to the first article that was not there a moment ago
        if (first) {
          var link = first.querySelector('h3 a');
          if (link) { link.setAttribute('tabindex', '-1'); link.focus(); }
        }
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(moveIndicator, 140);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(moveIndicator);

    render();
    requestAnimationFrame(moveIndicator);
  }

  boot();

  /* The editor replaces a section's markup wholesale on every change, so the
     script has to run again over the new nodes. Storefront visitors never get
     here -- they booted once above. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { boot(); });
  }
})();
